import request from '@/utils/request';
//优惠券列表
export function getCpUseList(values) {
  return request('/coupon/queryConsumePage', {
    method: 'POST',
    data: values,
  });
}
